// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                   from 'firebase/functions';

// ===== Services =====

import getCurrentActionOrigin       from './getCurrentActionOrigin';

// ===== Interfaces =====

import {
    ISendNewAccountOnboardingEmailPayload,
}                                   from '../interfaces';

const sendNewAccountOnboardingEmail = async ({
    test,
    temporaryPassword,
}: {
    test: boolean,
    temporaryPassword?: string,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleSendNewAccountOnboardingEmail = httpsCallable<
        ISendNewAccountOnboardingEmailPayload,
        boolean
    >(
        functions,
        'sendNewAccountOnboardingEmail',
    );
    const actionOrigin = getCurrentActionOrigin();
    const payload: ISendNewAccountOnboardingEmailPayload = {
        test,
        temporaryPassword,
    };
    if (actionOrigin) payload.actionOrigin = actionOrigin;
    return handleSendNewAccountOnboardingEmail(payload).then((result) => {
        const success = result.data as boolean;
        return success;
    }).catch((err) => {
        throw err;
    });
};

export default sendNewAccountOnboardingEmail;
